module.exports = __webpack_public_path__ + "static/11ACOfamilywall-5862618ba813578af5205517821be3cf.jpg";